import { render, staticRenderFns } from "./GridAccessPointBox.vue?vue&type=template&id=672c01b6"
import script from "./GridAccessPointBox.vue?vue&type=script&lang=ts"
export * from "./GridAccessPointBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports